import React from "react";
import { Link } from "react-router-dom";

const Reportes = () => {
  return (
    <div>
      <div className="flex w-full h-screen bg-backgroundClaro justify-center items-center">
        <div className="grid md:grid-cols-2 grid-cols-1 justify-between gap-24">
          <Link to="/reportes/salidas">
            <button
              type="button"
              className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform"
            >
              Reporte Salidas
            </button>
          </Link>
          <Link to="/reportes/ingresos">
            <button
              type="button"
              className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform"
            >
              Reporte Ingresos
            </button>
          </Link>
          <Link to="/reportes/prestamos">
            <button
              type="button"
              className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform"
            >
              Reporte Prestamos
            </button>
          </Link>
          <Link to="/reportes/stock">
            <button
              type="button"
              className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform"
            >
              Reporte Stock
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Reportes;
